import makeRequest from '@jg/http-client';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { Auth } from '@jg/auth';
import { httpActions, apiActions } from '..';
import {
  REQUEST,
  SHORT_NAME_MINIMUM_CHARACTER,
  ERROR_MESSAGES,
} from '../../consts';
import config from '../../config';
import { generateAuthHeaders, redirectByResponseStatus } from '../../utils';
import { IAppState } from '../../types/state.d';
import { clearShortNameValidity } from '../actionCreators/apiActions';

const checkShortName = (shortName: string) => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
  _state: () => IAppState,
  auth: Auth,
) => {
  const resourceName = REQUEST.CHECK_SHORT_NAME;
  try {
    if (shortName.length < SHORT_NAME_MINIMUM_CHARACTER) {
      dispatch(apiActions.clearShortNameValidity());
      return;
    }
    await auth.refreshAccessTokenIfExpired();
    dispatch(httpActions.httpRequestMade(resourceName));
    const response = await makeRequest(
      `${config.pagesAPI}v1/teams/shortNames/${shortName}/isAvailable`,
      {
        extraHeaders: generateAuthHeaders(auth),
      },
    );
    if (response && !response.ok) {
      redirectByResponseStatus(response.status);
      throw new Error(ERROR_MESSAGES.CHECK_SHORT_NAME);
    }
    const { isAvailable } = await response.json();
    dispatch(apiActions.isShortNameValid(isAvailable));
    dispatch(httpActions.httpRequestSuccess(resourceName));
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error));
    dispatch(clearShortNameValidity());
  }
};

export default checkShortName;
